import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'

import { textTranslation, shouldTranslateTo } from '../utils/utils'

import PhotosGrid from '../../../../public/images/homepage/photos-grid.png'
import PhotosGrid2 from '../../../../public/images/homepage/photos-grid-2.png'
import Photo1 from '../../../../public/images/homepage/photo-1.png'
import Photo2 from '../../../../public/images/homepage/photo-2.png'
import Photo3 from '../../../../public/images/homepage/photo-3.png'
import PhotosTrio from '../../../../public/images/homepage/photos-trio-2.png'
import Soon from '../../../../public/images/homepage/soon.png'
import TestimonialsCarousel from './TestimonialsCarousel'
import BikePeople from '../../../../public/images/homepage/bike-people.png'

import Publico from '../../../../public/images/homepage/icons/publico.svg'
import Times from '../../../../public/images/homepage/icons/the-times.svg'
import Forbes from '../../../../public/images/homepage/icons/forbes.svg'
import Irish from '../../../../public/images/homepage/icons/the-irish-times.svg'
import Telegraph from '../../../../public/images/homepage/icons/the-telegraph.svg'
import IndependentIe from '../../../../public/images/homepage/icons/independent-ie.svg'
import Huffpost from '../../../../public/images/homepage/icons/huffpost.svg'
import Nextavenues from '../../../../public/images/homepage/icons/nextavenue.svg'

import Estadao from '../../../../public/images/homepage/icons/estadao.svg'
//import Citylab from "../../../../public/images/homepage/icons/citylab.svg";
import Citylab from '../../../../public/images/homepage/icons/bloomberg.svg'
import Traveler from '../../../../public/images/homepage/icons/traveler.svg'
import Aarp from '../../../../public/images/homepage/icons/aarp.svg'
import Strait from '../../../../public/images/homepage/icons/strait.svg'
import Haaretz from '../../../../public/images/homepage/icons/haaretz.svg'
import Luxemburguer from '../../../../public/images/homepage/icons/luxemburguer.svg'
import Sabado from '../../../../public/images/homepage/icons/sabado.svg'
import Soir from '../../../../public/images/homepage/icons/soir.svg'
import Regione from '../../../../public/images/homepage/icons/regione.svg'
import Burcher from '../../../../public/images/homepage/icons/burcher.svg'
import FastCompany from '../../../../public/images/homepage/icons/fast_company.svg'
import FolhaSP from '../../../../public/images/homepage/icons/folha_sp.svg'

import Persona1 from '../../../../public/images/homepage/Personas/1.svg'
import Persona2 from '../../../../public/images/homepage/Personas/2.svg'
import Persona3 from '../../../../public/images/homepage/Personas/3.svg'
import Persona4 from '../../../../public/images/homepage/Personas/4.svg'
import Persona5 from '../../../../public/images/homepage/Personas/5.svg'

import { Link } from 'react-router-dom'
import LogosResponsiveCarousel from './LogosResponsiveCarousel'

const HomepageContainer = styled.div`
  background-color: #fff;
`

const Header = styled.div`
  background-color: #f2e8d8;
`

const ContainerFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props.gap ? props.gap : '0px')};
  padding: ${(props) => (props.padding ? props.padding : '0px')};

  ${(props) => props.gray && 'background-color: #F8F9F9'};
  ${(props) => props.background && `background-color: ${props.background}`};

  ${(props) => props.center && 'justify-content: center'};

  ${(props) =>
    props.spaceBetween &&
    'width: -webkit-fill-available; justify-content: space-between'};

  ${(props) => props.dark && 'background-color: #154549'};

  @media screen and (max-width: 1025px) {
    ${(props) => props.gapMd && `gap: ${props.gapMd}`};
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    ${(props) => props.columnHeader && 'flex-direction: column'};
  }

  @media screen and (max-width: 768px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '30px')};
    flex-direction: ${(props) =>
      props.columnReverse ? 'column-reverse' : 'column'};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

const FixFlexShrink = styled.div`
  flex-grow: 0;
  flex-shrink: 0.5;
  flex-basis: max-content;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    flex-basis: max-content !important;
    padding: 0 40px 0 40px;
    h1 {
      width: 100%;
    }
  }

  @media screen and (max-width: 1025px) {
    flex-basis: 40vw;
  }
`

const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) =>
    props.spaceBetween &&
    'width: -webkit-fill-available; justify-content: space-between'};
  ${(props) => props.gap && `gap: ${props.gap}`};
`

const ContainerFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${(props) => props.padding && `padding: ${props.padding}`};
  ${(props) => props.center && 'justify-content: center; align-items: center'};
  ${(props) => props.background && `background-color: ${props.background}`};

  @media screen and (max-width: 768px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

const ContainerFlexColumnStart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.center ? 'center' : 'flex-start')};
  align-items: flex-start;
  gap: ${(props) => (props.gap ? props.gap : '0px')};
  ${(props) => props.padding && `padding: ${props.padding}`};

  ${(props) => props.flexShrink && `flex-shrink: ${props.flexShrink}`};
  ${(props) => props.flexGrow && `flex-grow: ${props.flexGrow}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.gapMd && `gap: ${props.gapMd}`};
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.gapSm && `gap: ${props.gapSm}`};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
    flex-direction: ${(props) =>
      props.columnReverse ? 'column-reverse' : 'column'};
  }
`

const BrushStoke = styled.div`
  background-image: url('/images/homepage/brush.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px 20px 20px 40px;
  position: relative;
  left: -40px;
  width: 100%;

  @media screen and (max-width: 768px) {
    position: static;
    padding: 5px 8px;
  }
`

const Title = styled.h1`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  font-family: 'Open Sans', sans-serif !important;
  font-size: ${(props) => (props.size ? props.size : '50px')};
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};

  ${(props) => props.width && `width: ${props.width}`};
  b {
    color: #0bac5d;
  }

  @media screen and (max-width: 1025px) {
    font-size: ${(props) => (props.sizemd ? props.sizemd : '50px')};
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
    ${(props) => props.widthMd && `width: ${props.widthMd}`};
  }

  /* @media screen and (min-width: 768px) {
        ${(props) => props.width && `width: 100%`};
    } */

  @media screen and (max-width: 768px) {
    font-size: ${(props) => (props.sizesm ? props.sizesm : '42px')};
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center; width: 100%;'}
    ${(props) => props.width && `width: 100%`};
  }
`

const Green = styled.span`
  color: #0bac5d;
`

const Subtitle = styled.h2`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  font-family: 'Open Sans', sans-serif !important;
  font-size: ${(props) => (props.size ? props.size : '20px')};
  font-weight: ${(props) => (props.bold ? 'bold' : '400')};
  line-height: 146%;
  ${(props) => props.width && `width: ${props.width}`};
  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.sizemd && `font-size: ${props.sizemd}`};
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) =>
      props.sizesm ? `font-size: ${props.sizesm}` : 'font-size: 18px'};
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center'}
    ${(props) => props.width && `width: 100%`};
  }
`

const CustomTypography = styled.h2`
  color: #000;
  text-align: center;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 22px;
  font-weight: 400;
  line-height: 157%; /* 34.54px */
  letter-spacing: 8.14px;
  text-align: left;
  ${(props) => props.margin && `margin: ${props.margin}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center'}
  }
`

const Button = styled.button`
  border-radius: 5px;
  background: ${(props) => (props.background ? props.background : '#0BAC5D')};
  color: #fff;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 170%;
  border: none;

  /*
    commented out by PJ : 
    padding: ${(props) => (props.wider ? '11px 50px' : '11px 25px')};
    a {
        text-decoration: none;
        color: #fff;
    }
    */

  padding: 0;

  a {
    display: inline-block;
    color: #fff;
    text-decoration: none;
    height: 50px;
    vertical-align: middle;
    width: 100%;
    padding: ${(props) => (props.wider ? '9px 50px' : '9px 25px')};
  }

  @media screen and (max-width: 768px) {
    ${(props) => !props.noFill && `width: -webkit-fill-available;`};
  }
`

const Image = styled.div`
  ${(props) => (props.fitImage ? 'height: inherit;' : 'height: 100%;')};
  border-radius: 15px;
  text-align: center;
  ${(props) => props.background && 'background-color: #16494D'};

  img {
    width: ${(props) => (props.width ? props.width : '100%')};
    border-radius: 15px;
    ${(props) => props.fitImage && 'object-fit: cover; height: 100%;'}
  }

  @media screen and (max-width: 1025px) {
    img {
      width: ${(props) => (props.widthMd ? props.widthMd : '100%')};
    }
  }

  @media screen and (max-width: 768px) {
    img {
      width: 100%;
    }
  }
`

const TrustImage = styled(Image)`
  margin-top: -50px;

  @media screen and (max-width: 768px) {
    margin-top: 0px;
  }
`

const Logos = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5vh 0;
  ${(props) => props.padding && `padding: ${props.padding}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  ${(props) => props.margin && `margin: ${props.margin}`};
`

const BlueSection = styled.div`
  display: flex;
  height: ${(props) => (props.height ? props.height : '100%')};
  margin: 5vh 0;
  flex-direction: column;
  background-color: ${(props) => (props.beige ? '#F2E8D8' : '#E1F5F6')};
  width: 80%;
  justify-content: center;
  align-items: center;
  gap: 40px;
  ${(props) => props.padding && `padding: ${props.padding}`};

  /* h2 {
        text-align: center;
    } */

  @media screen and (max-width: 768px) {
    width: 90%;
    height: auto;
    padding: ${(props) => (props.paddingSm ? props.paddingSm : '70px 15px')};
  }
`

const Testimonails = styled.div`
  background: #f2e8d8 url(${(props) => props.image}) bottom left no-repeat;
  background-size: 100%;
  background-position-y: 105%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 75px 0 120px 0;

  overflow: hidden;

  & h1 {
    margin-bottom: 40px;
  }

  @media screen and (max-width: 768px) {
    background-size: 300%;
  }
`

const HelpContainer = styled.div`
  display: flex;
  width: 35vw;
  justify-content: space-between;
  align-items: center;
  padding: 18px;
  border-radius: 7px;
  background: #235054;
  margin-top: 18px;

  h2 {
    text-decoration: none;
    color: #fff;
  }

  & img {
    width: 5px;
    height: 11px;
    rotate: 180deg;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

const AwardSection = styled.div`
  width: 80%;

  @media screen and (max-width: 768px) {
    width: 100%;
    h1,
    h2 {
      text-align: center;
    }
  }
`

const AwardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* & > div {
        width: 80%;

        @media screen and (max-width: 768px) {
            width: 100%;
        }
    } */

  & > div {
    height: 200px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1025px) {
      width: 100%;
    }
  }

  h2 {
    text-align: center;
  }

  img {
    width: 100%;
    max-height: 190px;
  }
`

const LinkContainer = styled.div`
  width: -webkit-fill-available;
  a {
    text-decoration: none;
    color: #fff;
  }

  img {
    margin-left: 5px;
  }
`

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 50px 20px;
  background-color: #e1f5f7;

  & button {
    width: 20vw;
    margin-left: 10px;

    @media screen and (max-width: 768px) {
      width: -webkit-fill-available;
      margin-left: 0;
      height: 55px;
    }
  }
`

const SelectStyled = styled(Select)`
  width: 40vw;

  & > div:first-of-type {
    height: 55px;
  }

  @media screen and (max-width: 768px) {
    width: 90vw;
  }

  /* @media screen and (max-width: 600px) {
        height: 55px;
    } */
`

const CheckboxWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  align-items: center;

  label {
    font-family: 'Open Sans', sans-serif !important;
    font-size: 19px;
    font-weight: ${(props) => (props.checked ? 'bold' : 'normal')};
    line-height: 170%;
    color: #154549;
    margin-bottom: 0;

    @media screen and (max-width: 768px) {
      font-size: 16px;
      margin-bottom: 0;
      width: 72vw;
    }
  }

  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`

const CheckboxInput = styled.input`
  display: none;
`

const CustomCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  background-color: #fff;
  border-radius: 50%;
  border: 3px solid #154549;
  transition: background-color 0.2s;

  img {
    width: 18px;
  }
  @media screen and (max-width: 768px) {
    /* width: 40px; */
  }
`

const FreebirdSection = styled.div`
  margin-bottom: 25px;
  max-width: 230px;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 150px;
  }

  @media screen and (max-width: 768px) {
    img {
      margin-bottom: 25px;
    }
  }
`

const LineBreak = styled.div`
  height: 15px;
  background-color: #fff;
`

export const logosLink = [
  {
    image: Publico,
    link: 'https://www.publico.pt/2024/06/01/fugas/noticia/freebird-club-comunidade-viagens-maiores-50-quer-portugal-farol-2092505',
  },
  {
    image: Times,
    link: 'https://www.thetimes.co.uk/article/airbnb-style-hosting-site-for-over-50s-can-stop-loneliness-hmfvl6jrp',
  },
  {
    image: Forbes,
    link: 'https://www.forbes.com/sites/nextavenue/2017/12/05/the-freebird-club-an-airbnb-for-the-50-set/#3464acf6463c',
  },
  {
    image: Irish,
    link: 'https://www.irishtimes.com/life-and-style/abroad/free-as-a-bird-and-looking-for-a-room-1.3221351',
  },
  {
    image: Telegraph,
    link: 'http://www.telegraph.co.uk/property/renting/meet-the-freebird-club-a-new-typeof-airbnb-for-the-50-plus-adven/',
  },
  {
    image: Citylab,
    link: 'https://www.bloomberg.com/news/articles/2016-05-26/the-freebird-club-or-airbnb-for-the-elderly-combats-loneliness-in-cities',
  },

  {
    image: Huffpost,
    link: 'https://www.huffingtonpost.com/entry/airbnb-for-seniors-helps-link-travelers-with-like-minded-hosts_us_57487aa1e4b0dacf7ad4c130?guccounter=1',
  },
  {
    image: IndependentIe,
    link: 'https://www.independent.ie/life/travel/travel-news/empty-nesters-get-set-to-fly-36449163.html',
  },

  {
    image: Estadao,
    link: 'https://www.estadao.com.br/economia/irlandes-lanca-airbnb-de-idosos/',
  },
  {
    image: Nextavenues,
    link: 'http://www.nextavenue.org/freebird-club-airbnb-50/',
  },
  {
    image: Traveler,
    link: 'https://www.traveler.es/experiencias/articulos/freebird-club-comunidad-viajera-para-mayores-de-50-anos/13165',
  },
  {
    image: Haaretz,
    link: 'https://www.haaretz.com/world-news/europe/2016-06-25/ty-article/new-travel-club-is-glad-to-be-gray/0000017f-df1c-d856-a37f-ffdc6a3b0000',
  },
  {
    image: Luxemburguer,
    link: 'https://www.wort.lu/panorama/un-club-de-voyage-pas-comme-les-autres/829819.html',
  },
  {
    image: Sabado,
    link: 'https://www.sabado.pt/opiniao/convidados/joao-costa/detalhe/economia-de-partilha-chega-aos-idosos?utm_medium=Social&utm_source=Facebook&utm_campaign=Echobox&utm_term=Autofeed',
  },
  {
    image: Soir,
    link: 'https://www.lesoir.be/art/1248821/article/actualite/monde/impact-journalism-day/2016-06-24/freebird-un-club-voyage-en-peer-to-peer-pas-comme-autres',
  },
  {
    image: Regione,
    link: 'https://www.laregione.ch/rubriche/impact-journalism/1202452/in-vacanza-dal-nonno',
  },
  {
    image: Aarp,
    link: 'https://seniorplanet.org/the-freebird-club-a-new-airbnb-just-for-seniors/',
  },
  {
    image: Burcher,
    link: 'https://www.nzz.ch/gesellschaft/generationen/generationen-wie-wir-zusammenleben-die-alten-wilden-ld.121542?reduced=true',
  },
  {
    image: FastCompany,
    link: 'https://www.fastcompany.com/3060166/can-this-airbnb-for-seniors-help-keep-the-elderly-connected',
  },
  {
    image: Strait,
    link: 'https://www.straitstimes.com/world/europe/a-travel-club-for-seniors',
  },
  {
    image: FolhaSP,
    link: 'https://www1.folha.uol.com.br/ciencia/2016/06/1784835-clube-de-viagens-para-idosos-quer-acabar-com-a-solidao-e-o-isolamento.shtml',
  },
]

export const TestimonialsSection = ({ pageText }) => {
  return (
    <Testimonails image={PhotosGrid2}>
      <Title>{pageText[68]}</Title>
      <TestimonialsCarousel />
    </Testimonails>
  )
}

const Award = ({ title, image }) => {
  return (
    <AwardContainer>
      <div>
        <img src={image} />
      </div>
      <Subtitle
        size="18px"
        sizemd="18px"
        sizesm="18px"
        bold
        dangerouslySetInnerHTML={{ __html: `${title}` }}
      ></Subtitle>
    </AwardContainer>
  )
}

export const AwardsSection = ({ pageText }) => {
  return (
    <ContainerFlexColumn
      padding="6vh 10vw 8vh 10vw"
      center
      background="#fff"
      paddingMd="6vh 5vw 8vh 5vw"
      paddingSm="6vh 5vw 8vh 5vw"
    >
      <AwardSection>
        <Title
          sizesm="36px"
          center
          margin="0 0 40px 0"
          marginmd="0 0 20px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[55]}`,
          }}
        ></Title>
        <Subtitle
          size="18px"
          sizesm="18px"
          center
          margin="0 0 60px 0"
          marginmd="0 0 30px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[56]}`,
          }}
        ></Subtitle>
      </AwardSection>
      <ContainerFlexRow spaceBetween gap="80px" gapMd="20px" gapSm="20px">
        <Award
          image={'/images/logos/europeanCommission.svg'}
          title={pageText[57]}
        />
        <Award image={'/images/logos/europeanBank.svg'} title={pageText[58]} />
        <Award image={'/images/logos/ukri.svg'} title={pageText[59]} />
      </ContainerFlexRow>
      <ContainerFlexRow
        spaceBetween
        gap="80px"
        gapMd="20px"
        gapSm="20px"
        padding="50px 0 0 0"
      >
        <Award image={'/images/logos/untwo.svg'} title={pageText[60]} />
        <Award image={'/images/logos/worldTurism.svg'} title={pageText[61]} />
        <Award image={'/images/logos/again.svg'} title={pageText[62]} />
      </ContainerFlexRow>
    </ContainerFlexColumn>
  )
}

const Homepage = () => {
  const [pageText, setPageText] = React.useState([])
  const [countries, setCountries] = React.useState([])
  const [selectedCountry, setSelectedCountry] = React.useState()
  const [checked, setChecked] = React.useState('locals')
  const [imageSign, setImageSign] = React.useState('')

  React.useEffect(() => {
    const language = shouldTranslateTo()
    setImageSign(`/images/homepage/Signs/${language}.svg`)
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('homepage', language)

    getCountries('locals')
  }, [])

  const getCountries = (seeking) => {
    axios.get(`/api/available-countries?type=${seeking}`).then((response) => {
      let countries = response.data
      countries = countries.map((country) => {
        return { label: country.nicename, value: country.id }
      })

      setCountries(countries)
    })
  }

  const handleCountry = (country) => {
    setSelectedCountry(country)
  }

  const HelpItem = ({ text, link }) => {
    return (
      <LinkContainer>
        <Link to={link}>
          <HelpContainer>
            <Subtitle size="19px" sizemd="17px" white>
              {text}
            </Subtitle>
            <img src="/images/homepage/icons/arrow-line.svg" />
          </HelpContainer>
        </Link>
      </LinkContainer>
    )
  }

  const Freebirds = ({ img, title, text, cls }) => {
    return (
      <FreebirdSection>
        <img src={img} className={cls} />
        <Subtitle
          smCenter
          bold
          size="20px"
          sizemd="20px"
          margin="20px 0 20px 0"
          dangerouslySetInnerHTML={{ __html: `${title}` }}
        ></Subtitle>
        <Subtitle
          smCenter
          size="16px"
          sizemd="16px"
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        ></Subtitle>
      </FreebirdSection>
    )
  }

  const HandleSearch = () => {
    window.location.href = `/search?seeking=${checked}${
      selectedCountry !== null && selectedCountry !== undefined
        ? '&country=' + selectedCountry.value
        : ''
    }`
  }

  console.log('pageText.length: ' + pageText.length)

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <HomepageContainer>
      {/* //Header    */}
      <Header>
        <ContainerFlexRow
          gap="50px"
          gapMd="30px"
          padding="10vh 40px 4vh 5vw"
          paddingSm="5vh 2vw 4vh 2vw"
          columnHeader
          fixedWidth="590px"
        >
          <FixFlexShrink>
            <Title
              width="530px"
              size="4em"
              sizemd="70px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[0]}`,
              }}
            ></Title>
            <Title width="530px" size="4em" sizemd="70px" marginsm="0 0 0 8px">
              <Green> {pageText[1]}</Green>
            </Title>
          </FixFlexShrink>
          <ContainerFlexColumnStart
            gap="15px"
            gapMd="15px"
            padding="0 40px 0 40px"
            paddingSm="0"
            flexGrow="0"
            flexShrink="1"
          >
            <Subtitle
              bold
              size="27px"
              sizemd="27px"
              sizesm="17px"
              marginsm="0 0 0 8px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[2]}`,
              }}
            ></Subtitle>
            <BrushStoke>
              <Subtitle
                size="21px"
                sizemd="22px"
                sizesm="17px"
                marginsm="15px 0 15px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[3]}`,
                }}
              ></Subtitle>
            </BrushStoke>
            <Button>
              <Link to="/signup">{pageText[4]}</Link>
            </Button>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
        <Image>
          <img src={PhotosGrid} />
        </Image>
      </Header>
      <LineBreak />
      {/* //Search section */}
      <SearchContainer>
        <Subtitle
          bold
          size="35px"
          sizesm="22px"
          margin="0 0 20px 0"
          smCenter
          marginsm="0 0 30px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[5]}`,
          }}
        ></Subtitle>
        <ContainerFlexRow gap="15px" gapMd="15px" gapSm="10px">
          <SelectStyled
            placeholder={pageText[63]}
            defaultValue={''}
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            name="country"
            options={countries}
            onChange={(props) => handleCountry(props)}
            value={selectedCountry}
          />
          <Button
            background="#154549"
            isDisabled={selectedCountry === null}
            onClick={HandleSearch}
          >
            {pageText[64]}
          </Button>
        </ContainerFlexRow>
        <ContainerFlexRow gap="70px" gapSm="20px" paddingSm="30px 0 0 0">
          <CheckboxWrapper checked={checked === 'locals'}>
            <CheckboxInput
              type="checkbox"
              onChange={() => {
                setChecked('locals'), getCountries('locals')
              }}
            />
            <CustomCheckbox
              checked={checked === 'locals'}
              onClick={() => {
                setChecked('locals'), getCountries('locals')
              }}
            >
              {checked === 'locals' && <img src="/images/check-icon.svg" />}
            </CustomCheckbox>
            <label
              onClick={() => {
                setChecked('locals'), getCountries('locals')
              }}
              dangerouslySetInnerHTML={{
                __html: `${pageText[6]}`,
              }}
            ></label>
          </CheckboxWrapper>
          <CheckboxWrapper checked={checked === 'homestays'}>
            <CheckboxInput
              type="checkbox"
              checked={checked === 'homestays'}
              onChange={() => {
                setChecked('homestays'), getCountries('homestays')
              }}
            />
            <CustomCheckbox
              checked={checked === 'homestays'}
              onClick={() => {
                setChecked('homestays'), getCountries('homestays')
              }}
            >
              {checked === 'homestays' && <img src="/images/check-icon.svg" />}
            </CustomCheckbox>
            <label
              onClick={() => {
                setChecked('homestays'), getCountries('homestays')
              }}
              dangerouslySetInnerHTML={{
                __html: `${pageText[7]}`,
              }}
            ></label>
          </CheckboxWrapper>
        </ContainerFlexRow>
      </SearchContainer>
      {/* //Magazine Logos section */}
      <Logos padding="10vh 7vw 10vh 7vw">
        <Title
          center
          size="50px"
          margin="0 0 30px 0"
          smCenter
          dangerouslySetInnerHTML={{
            __html: `${pageText[37]}`,
          }}
        ></Title>
        {/*
                <Subtitle
                    center
                    width="60%"
                    margin="0 0 20px 0"
                    dangerouslySetInnerHTML={{
                        __html: `${pageText[38]}`
                    }}
                ></Subtitle>
                */}
        <LogosResponsiveCarousel logosLink={logosLink} />
      </Logos>
      {/* //What is section */}
      <ContainerFlexRow
        gray
        gap="50px"
        padding="10vh 7vw 10vh 7vw"
        paddingSm="4vh 7vw 6vh 7vw"
        paddingMd="7vh 40px 5vh 6vw"
        gapMd="20px"
      >
        <ContainerFlexColumnStart gap="20px" center>
          <Title
            dangerouslySetInnerHTML={{
              __html: `${pageText[8]}`,
            }}
          ></Title>
          <Subtitle
            bold
            size="27px"
            sizemd="22px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[9]}`,
            }}
          ></Subtitle>
          <Subtitle
            bold
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[10]}`,
            }}
          ></Subtitle>
          <Subtitle
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[11]}`,
            }}
          ></Subtitle>
          <Button>
            <Link
              to="/signup"
              dangerouslySetInnerHTML={{
                __html: `${pageText[12]}`,
              }}
            ></Link>
          </Button>
        </ContainerFlexColumnStart>
        <Image width="45vw" widthMd="40vw">
          <img src={PhotosTrio} />
        </Image>
      </ContainerFlexRow>
      {/* //Freebirds at home section */}
      <ContainerFlexColumn
        center
        padding="12vh 40px 12vh 5vw"
        paddingSm="12vh 5vw 6vh 5vw"
        background="#fff"
      >
        <Title
          smCenter
          size="50px"
          margin="0 0 30px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[13]}` }}
        ></Title>
        <Subtitle
          center
          bold
          margin="0 0 20px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[14]}`,
          }}
        ></Subtitle>
        <Subtitle
          center
          width="50%"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[15]}`,
          }}
        ></Subtitle>
        <ContainerFlexRow gap="90px" gapMd="40px">
          <Freebirds
            img={Persona1}
            title={pageText[16]}
            text={pageText[17]}
            cls={'bottom-pad'}
          />
          <Freebirds
            img={Persona2}
            title={pageText[18]}
            text={pageText[19]}
            cls={''}
          />
          <Freebirds
            img={Persona3}
            title={pageText[20]}
            text={pageText[21]}
            cls={''}
          />
          <Freebirds
            img={Persona4}
            title={pageText[22]}
            text={pageText[23]}
            cls={''}
          />
        </ContainerFlexRow>
      </ContainerFlexColumn>
      {/* //Testimonials section */}
      <TestimonialsSection pageText={pageText} />
      {/* //Our community section */}
      <ContainerFlexRow
        gray
        gap="80px"
        padding="12vh 40px 12vh 5vw"
        paddingSm="12vh 5vw 6vh 5vw"
      >
        <ContainerFlexColumnStart gap="50px" gapMd="20px" gapSm="30px" center>
          <Title sizemd="50px" sizesm="30px">
            {pageText[24]} <Green>{pageText[25]}</Green>
          </Title>
          <Subtitle
            bold
            size="27px"
            sizemd="22px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[26]}`,
            }}
          ></Subtitle>
          <Subtitle
            size="18px"
            sizemd="18px"
            sizesm="16px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[27]}`,
            }}
          ></Subtitle>
          <Subtitle
            bold
            size="18px"
            sizemd="18px"
            sizesm="16px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[28]}`,
            }}
          ></Subtitle>
          <Button>
            <Link to="/signup">{pageText[65]}</Link>
          </Button>
        </ContainerFlexColumnStart>
        <Image fitImage background width="35vw" widthMd="40vw">
          <img src={BikePeople} />
        </Image>
      </ContainerFlexRow>
      {/* //Pay as you wish section */}
      <ContainerFlexRow
        background="#E1F5F7"
        gap="50px"
        padding="12vh 7vw 12vh 7vw"
        paddingSm="10vh 7vw 12vh 7vw"
        columnReverse
      >
        <Image width="435px" widthMd="435px">
          {imageSign ? (
            <img src={imageSign} />
          ) : (
            <img src={'/images/homepage/Signs/en.svg'} />
          )}
        </Image>
        <ContainerFlexColumnStart gap="30px" gapMd="20px" gapSm="30px" center>
          <Title sizemd="40px" sizesm="36px">
            {pageText[74]} <Green>{pageText[75]}</Green>
          </Title>
          <Subtitle
            bold
            size="27px"
            sizemd="20px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[76]}`,
            }}
          ></Subtitle>
          <Subtitle
            size="18px"
            sizemd="20px"
            sizesm="16px"
            dangerouslySetInnerHTML={{ __html: `${pageText[77]}` }}
          ></Subtitle>
          <Subtitle
            size="18px"
            sizemd="20px"
            sizesm="16px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[78]}`,
            }}
          ></Subtitle>
          <Button>
            <Link to="/signup">{pageText[79]}</Link>
          </Button>
        </ContainerFlexColumnStart>
      </ContainerFlexRow>
      {/* //Become a host section */}
      <ContainerFlexRow
        gap="100px"
        padding="10vh 7vw 10vh 7vw"
        center
        dark
        columnReverse
      >
        <Image background fitImage width="40vw" widthMd="40vw">
          <img src={Photo3} />
        </Image>
        <ContainerFlexColumnStart gap="30px" gapMd="20px" gapSm="30px" center>
          <Title white sizemd="40px" sizesm="36px" smCenter>
            {pageText[69]} <Green>{pageText[70]}</Green>
          </Title>
          <Subtitle
            white
            bold
            size="22px"
            sizemd="20px"
            sizesm="18px"
            smCenter
            dangerouslySetInnerHTML={{
              __html: `${pageText[71]}`,
            }}
          ></Subtitle>
          <Subtitle
            white
            size="18px"
            sizemd="20px"
            sizesm="16px"
            smCenter
            dangerouslySetInnerHTML={{
              __html: `${pageText[72]}`,
            }}
          ></Subtitle>
          <Button wider>
            <Link to="/become-host">{pageText[73]}</Link>
          </Button>
        </ContainerFlexColumnStart>
      </ContainerFlexRow>
      {/* //Trust & security section */}
      <ContainerFlexRow gap="40px" gapMd="30px" padding="8vh 4vw 8vh 7vw">
        <ContainerFlexColumnStart
          gap="30px"
          gapMd="15px"
          gapSm="30px"
          padding="0 80px 0 0"
          paddingMd="0"
          paddingSm="0"
          center
        >
          <Title>
            {pageText[29]} <Green>{pageText[30]}</Green>
          </Title>
          <Subtitle
            bold
            size="22px"
            dangerouslySetInnerHTML={{ __html: `${pageText[31]}` }}
          ></Subtitle>
          <Subtitle
            size="18px"
            dangerouslySetInnerHTML={{ __html: `${pageText[32]}` }}
          ></Subtitle>
        </ContainerFlexColumnStart>
        <TrustImage width="35vw" widthMd="45vw">
          <img src={Persona5} />
        </TrustImage>
      </ContainerFlexRow>
      {/* //Get started section */}
      <ContainerFlexRow
        gray
        gap="50px"
        gapMd="40px"
        padding="10vh 7vw 10vh 7vw"
        columnReverse
      >
        <Image fitImage background width="35vw" widthMd="40vw">
          <img src={Photo1} />
        </Image>
        <ContainerFlexColumnStart gap="25px" center>
          <Title sizemd="40px">
            {pageText[33]} <br></br>
            <Green>{pageText[34]}</Green>
          </Title>
          <Subtitle
            bold
            size="27px"
            sizemd="20px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[35]}`,
            }}
          ></Subtitle>
          <Subtitle
            size="22px"
            sizemd="20px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[36]}`,
            }}
          ></Subtitle>
          <Button wider>
            <Link to="/signup">{pageText[66]}</Link>
          </Button>
        </ContainerFlexColumnStart>
      </ContainerFlexRow>
      {/* //Comming Soon section */}
      {/* <FlexCenter margin='5vh 0 5vh 0'>
                <BlueSection paddingSm='20px 15px 30px 15px' beige>
                    <CustomTypography margin='4vh 0 0 0'>{pageText[39]}</CustomTypography>
                    <Image width='80%' widthMd='80%'>
                        <img src={Soon} />
                    </Image>
                    <ContainerFlexRow gap='50px' padding='2vh 7vw 10vh 7vw'>
                        <ContainerFlexColumnStart >
                            <Subtitle bold size='22px' margin='0 0 10px 0' sizemd='17px' marginmd='0 0 3px 0' smCenter>{pageText[40]} </Subtitle>
                            <Subtitle size='22px' margin='0 0 10px 0' sizemd='17px' marginmd='0 0 3px 0' smCenter>{pageText[41]} </Subtitle>
                            <Subtitle bold size='22px' margin='0 0 10px 0' sizemd='17px' marginmd='0 0 3px 0' smCenter>{pageText[42]} </Subtitle>
                            <Subtitle size='22px' sizemd='17px' smCenter>{pageText[43]}  </Subtitle>
                            <CustomTypography margin='70px 0 30px 0' marginmd='20px 0 10px 0' smCenter>{pageText[44]}</CustomTypography>
                            <Button background='#154549'>
                                <Link to='/search?seeking=homestays'>
                                    {pageText[67]}
                                </Link>
                            </Button>
                        </ContainerFlexColumnStart>
                        <Image background width='30vw' widthMd='31vw'>
                            <img src={Photo2} />
                        </Image>
                    </ContainerFlexRow>
                </BlueSection>
            </FlexCenter> */}
      {/* //Help section */}
      <ContainerFlexRow gap="100px" padding="10vh 7vw 10vh 7vw" center dark>
        <ContainerFlexColumn>
          <SmallRow spaceBetween>
            <Subtitle
              bold
              size="27px"
              sizemd="25px"
              white
              dangerouslySetInnerHTML={{
                __html: `${pageText[45]}`,
              }}
            ></Subtitle>
            <Button noFill>
              <Link to="/faq">{pageText[46]}</Link>
            </Button>
          </SmallRow>
          <HelpItem text={pageText[47]} link="/faq" />
          <HelpItem text={pageText[48]} link="/faq" />
          <HelpItem text={pageText[49]} link="/faq" />
        </ContainerFlexColumn>
        <ContainerFlexColumn>
          <SmallRow spaceBetween>
            <Subtitle
              bold
              size="27px"
              sizemd="25px"
              white
              dangerouslySetInnerHTML={{
                __html: `${pageText[50]}`,
              }}
            ></Subtitle>
            <Button noFill>
              <Link to="/blog">{pageText[51]}</Link>
            </Button>
          </SmallRow>
          <HelpItem text={pageText[52]} link="/post/49" />
          <HelpItem text={pageText[53]} link="/post/45" />
          <HelpItem text={pageText[54]} link="/post/35" />
        </ContainerFlexColumn>
      </ContainerFlexRow>
      {/* //Awards section */}
      <AwardsSection pageText={pageText} />
    </HomepageContainer>
  )
}

export default Homepage
